/* eslint-disable jsx-a11y/media-has-caption */
import { useCallback, useState, useEffect, useRef } from 'react';
import { random } from 'utils/random';
import './aprilFoolsJory.scss';
import classNames from 'classnames';

const SUPPORTS_ANIMATION_FRAME =
  'requestAnimationFrame' in window && 'cancelAnimationFrame' in window;
const CAN_FRAME =
  process.env?.NODE_ENV === 'development' ||
  window?.location?.hostname?.toLowerCase().endsWith('netlify.app');

const NINZA_MODE =
  new URLSearchParams(window.location?.search).get('ninza')?.toLowerCase() ===
  'true';

const AprilFoolsJory = ({ children }) => {
  const bruhRef = useRef<HTMLAudioElement>();
  const [showing, setShowing] = useState(false);
  const playBruh = useCallback(() => {
    bruhRef.current?.play();
  }, []);
  const queuePopup = useCallback(() => {
    const cooldown = random(5000, 10000); // random(15000, 45000);
    const queueStart = Date.now();
    const animate = () => {
      const timeElapsed = Date.now() - queueStart;
      if (timeElapsed >= cooldown) {
        setShowing(true);
        playBruh();
      } else {
        requestAnimationFrame(animate);
      }
    };
    if (SUPPORTS_ANIMATION_FRAME) {
      requestAnimationFrame(animate);
    } else {
      setTimeout(() => {
        setShowing(true);
        playBruh();
      }, cooldown);
    }
  }, [playBruh, setShowing]);
  // useEffect(() => {
  //   queuePopup();
  // }, [queuePopup]);
  const close = useCallback(() => {
    setShowing(false);
    queuePopup();
    playBruh();
  }, [queuePopup, playBruh]);
  useEffect(() => {
    // force a refresh after an hour
    setTimeout(() => window.location.reload(), 1 * 1000 * 60 * 60);
  }, []);

  return (
    <div className='jory-fools'>
      {/* @ts-ignore */}
      <audio src='/bruh.mp3' controls={false} ref={bruhRef} />
      {showing && (
        <div className='jory-image'>
          <img src='/jory.jpg' alt='jory' />
          <p>Bruh</p>
          <button
            onClick={close}
            type='button'
            className={classNames(NINZA_MODE && 'ninza-mode')}
          >
            Close
          </button>
        </div>
      )}
      {!showing && (CAN_FRAME ? children : 'Please use the real site')}
    </div>
  );
};

export default AprilFoolsJory;
